import React from 'react';
import { Data as StudioData } from 'Clients/Studio';

interface MaintenanceAlertProps {
}
export const MaintenanceAlert: React.StatelessComponent<MaintenanceAlertProps> = (props) => {

  const message = StudioData.getMaintenanceMessage();

  if (message.enabled) {
    return <div
      style={{
        display: 'flex',
        background: '#F6D55C',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '0.75em',
        lineHeight: 'normal',
        padding: '3px 5px',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <span dangerouslySetInnerHTML={{ __html: message.message }}></span>
    </div>;
  }
  return null;
};
